<script context="module">import NumberFlowLite, { define } from "number-flow/lite";
export class NumberFlowElement extends NumberFlowLite {
  set __svelte_batched(batched) {
    this.batched = batched;
  }
  set data(data) {
    super.data = data;
  }
}
Object.keys(NumberFlowElement.defaultProps).forEach((key) => {
  Object.defineProperty(NumberFlowElement.prototype, `__svelte_${key.toLowerCase()}`, {
    set(value) {
      this[key] = value;
    },
    enumerable: true,
    configurable: true
  });
});
define("number-flow-svelte", NumberFlowElement);
</script>

<script>import {
  renderInnerHTML,
  formatToData
} from "number-flow/lite";
import { writable } from "svelte/store";
import { getGroupContext } from "./group.js";
import { BROWSER } from "esm-env";
export let locales = void 0;
export let format = void 0;
export let value;
export let prefix = void 0;
export let suffix = void 0;
export let willChange = false;
export let transformTiming = NumberFlowElement.defaultProps.transformTiming;
export let spinTiming = NumberFlowElement.defaultProps.spinTiming;
export let opacityTiming = NumberFlowElement.defaultProps.opacityTiming;
export let animated = NumberFlowElement.defaultProps.animated;
export let respectMotionPreference = NumberFlowElement.defaultProps.respectMotionPreference;
export let trend = NumberFlowElement.defaultProps.trend;
export let plugins = NumberFlowElement.defaultProps.plugins;
export let digits = NumberFlowElement.defaultProps.digits;
export let el = void 0;
const elStore = writable(el);
$: $elStore = el;
$: formatter = new Intl.NumberFormat(locales, format);
$: data = formatToData(value, formatter, prefix, suffix);
const group = getGroupContext();
group?.register?.(elStore);
</script>

<number-flow-svelte
	bind:this={el}
	{...$$restProps}
	data-will-change={willChange ? '' : undefined}
	on:animationsstart
	on:animationsfinish
	__svelte_batched={Boolean(group)}
	__svelte_transformtiming={transformTiming}
	__svelte_spintiming={spinTiming}
	__svelte_opacitytiming={opacityTiming}
	__svelte_animated={animated}
	__svelte_respectmotionpreference={respectMotionPreference}
	__svelte_trend={trend}
	__svelte_plugins={plugins}
	__svelte_digits={digits}
	{data}
>
	{@html BROWSER ? undefined : renderInnerHTML(data)}
</number-flow-svelte>
